import seoMetadata from '../seo/metadata';
import { getAdImageUrl } from './adImageUrl';

const { SERVICE_LABELS, getGameName } = seoMetadata;

export const AD_SHARE_PREFIX = 'AD_SHARE:';

const TOP_UP_TYPE_LABELS = {
  'autoclaim-uid': 'Top-up by ID',
  'login-method': 'Login method',
  'redeem-code': 'Redeem code',
  donation: 'Donation',
};

const uniqueJoin = (parts) => {
  const out = [];
  for (const part of parts) {
    const value = String(part || '').trim();
    if (!value) continue;
    const lower = value.toLowerCase();
    if (out.some((existing) => existing.toLowerCase() === lower)) continue;
    out.push(value);
  }
  return out.join(', ');
};

export function parseAdShareMessage(content) {
  if (content == null) return null;
  const raw = typeof content === 'string' ? content : String(content);
  const trimmed = raw.trim();
  if (!trimmed.startsWith(AD_SHARE_PREFIX)) return null;
  const rest = trimmed.slice(AD_SHARE_PREFIX.length);
  const newline = rest.indexOf('\n');
  const jsonPart = (newline === -1 ? rest : rest.slice(0, newline)).trim();
  const text = newline === -1 ? '' : rest.slice(newline + 1).replace(/^\n+/, '');
  try {
    const share = JSON.parse(jsonPart);
    if (!share || typeof share !== 'object') return null;
    return { share, text };
  } catch {
    return null;
  }
}

export function encodeAdShareMessage(share, text) {
  return `${AD_SHARE_PREFIX}${JSON.stringify(share)}\n\n${text || ''}`;
}

export function buildAdSharePayload(ad) {
  if (!ad?.id) return null;
  const gameName = getGameName(ad.game);
  const serviceLabel = SERVICE_LABELS[ad.service_type] || ad.service_type || '';
  const image = getAdImageUrl(Array.isArray(ad.image_urls) ? ad.image_urls[0] : ad.image_urls);
  const delivery = ad.metadata?.delivery_method || ad.delivery_method || '';
  const topUpType = TOP_UP_TYPE_LABELS[delivery] || (delivery ? String(delivery).replace(/-/g, ' ') : '');

  let line2 = '';
  if (ad.service_type === 'top-ups' && topUpType) {
    line2 = `Top-up type: ${topUpType}`;
  } else if (topUpType) {
    line2 = `Delivery: ${topUpType}`;
  } else if (serviceLabel) {
    line2 = `Type: ${serviceLabel}`;
  }

  return {
    ad_id: ad.id,
    title: ad.title || '',
    image: image || '',
    line1: uniqueJoin([gameName, serviceLabel, ad.title]),
    line2,
  };
}
